import AgentForm from "../pages/AgentForm";
import BookingReceipt from "@pages/myBookings/BookingReceipt";
import { Routes, Route, Navigate } from "react-router-dom";
import App from "App";
import {
  Explore,
  Landing2,
  Property,
  AccountSelection,
  VerifyEmail,
  ResetPassword,
  ChangePassword,
  ChangePasswordSuccess,
  Blank,
  Overview,
  Wallet,
  Listing,
  ListProperty,
  Profile,
  Messaging,
  Invoice,
  MyProperties,
  RedirectPage,
  Faq,
  TermsAndCondition,
  Privacy,
  CancellationPolicyPage,
  Contact,
  AcceptTransaction,
  PaymentSuccessPage,
  About,
  ReverifyEmail,
  PropertiesPage,
  Booking,
  BookingConfirm,
} from "../pages/index";

import { Settings } from "@pages/Settings";

import { PrivateRoutes } from "./PrivateRoutes";
import { SessionRoutes } from "./SessionRoutes";
import { EditProfile } from "@pages/Profile/Edit";
import PickAdate from "@pages/Requests/PickAdate";
import Preview from "@pages/MyProperties/Preview";
import NotFoundPage from "@pages/404/NotFoundPage";
import { MyBookings } from "@pages/myBookings";
import BookingDetail from "@pages/myBookings/BookingDetail";
import Staycation from "@pages/Staycation";
import Packages from "@pages/Staycation/packages";
import StaycationContact from "@pages/Staycation/contact";
import TAndC from "@pages/Staycation/tandc";
import DevelopersDashboard from "@pages/Developers/Dashboard";
import Projects from "@pages/Developers/Projects";
import ProjectDetails from "@pages/Developers/Projects/project-details";
import ProjectForm from "@pages/Developers/Projects/project-form";
import DevelopersProfile from "@pages/Developers/Profile";
import EditDeveloperProfile from "@pages/Developers/Profile/edit-profile";
import DevelopersSales from "@pages/Developers/Sales";
import AddProperty from "@pages/Developers/Projects/add-property";
import DeveloperAccount from "@pages/Developers/developer-account";
import { DevMessaging } from "@pages/Developers/Forum";
import ProjectProperty from "@pages/Developers/Projects/Property/project-property";
import DeveloperAccountProjects from "@pages/Developers/Projects/developer-account-projects";
import DevAccountProjectProperty from "@pages/Developers/Projects/dev-account-project-property";
import DeveloperUpload from "@pages/SignUp/DeveloperUpload";
import UserInterestPropertyDetails from "@pages/Client/InterstPropertyDetails";
import UserPurchasedPropertyDetails from "@pages/Client/PurchasePropertyDetails";
import ViewDeveloperProfile from "@pages/Developers/Projects/Property/view-dev-prof";
import Purchases from "@pages/Purchases";
import AddNewForum from "@pages/Developers/Forum/new-forum";
import DevInterestDetails from "@pages/Developers/Sales/dev-interest-details";
import UsersDashboard from "@pages/UsersDashboard";
import { DevelopersSettings } from "@pages/Developers/Settings";
import AllRequests from "@pages/Requests/AllRequests";
import RequestBookingDetail from "@pages/Requests/BookingDetail";
import { AllReviewsPage } from "@pages/AllReviewsPage";
import AgentTermsAndCondition from "@pages/AgentTerms";
import { More } from "@pages/more/more";
import CautionFeeDetails from "../pages/CautionFeeDetails";
import HostWallet from "../pages/HostWallet";
import NotificationsPage from "../pages/Notifications";
import RenewRent from "@pages/myBookings/RenewRent";

// import {useEffect} from 'react';

const AppRouter = () => {
  // useEffect(() => {
  //   const head = document.head;
  //   const title = document.getElementsByTagName('title')[0];
  //   const metaDescription = document.querySelector('meta[name="description"]');

  //   if (title) {
  //     head.insertBefore(title, head.firstChild);
  //   }

  //   if (metaDescription) {
  //     head.insertBefore(metaDescription, head.firstChild);
  //   }
  // }, [document.head, document.title]);
  return (
    <Routes>
      <Route path="/" element={<Landing2 />} />
      <Route path="/agent-form" element={<AgentForm />} />
      <Route path="/krentmedia" element={<More />} />
      <Route path="/staycation" element={<Staycation />} />
      <Route path="/staycation-packages" element={<Packages />} />
      <Route path="/staycation-contact" element={<StaycationContact />} />
      <Route path="/staycation-terms" element={<TAndC />} />
      <Route path="/blank" element={<Blank />} />
      <Route path="/explore" element={<Explore />} />
      <Route path="/shortlet" element={<Explore />} />
      <Route path="/property/:id/*" element={<Property />} />
      <Route path="/properties" element={<Explore />} />
      <Route path="/properties/:id" element={<Preview />} />
      <Route path="/app" element={<App />} />
      <Route path="/faq" element={<Faq />} />
      <Route path="/about" element={<About />} />
      <Route path="/terms" element={<TermsAndCondition />} />
      <Route path="/terms-of-service" element={<AgentTermsAndCondition />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/cancellation-policy" element={<CancellationPolicyPage />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/booking/new" element={<Booking />} />
      <Route path="/booking/:bookingId" element={<Booking />} />
      <Route path="/property/:slug/book" element={<Booking />} />
      <Route path="/booking/confirm" element={<BookingConfirm />} />
      <Route path="/property-for-:type" element={<PropertiesPage />} />
      <Route path="/property-for-:type/:kind" element={<PropertiesPage />} />
      <Route path="/developer-listings" element={<DeveloperAccount />} />
      <Route
        path="/developer-projects/:id"
        element={<DeveloperAccountProjects />}
      />
      <Route
        path="/developer-project-property/:id"
        element={<DevAccountProjectProperty />}
      />
      <Route path="/dev-profile" element={<ViewDeveloperProfile />} />
      <Route path="/all-reviews/:id" element={<AllReviewsPage />} />

      {/* <Route
        path='/property-for-:type/kind/:kind'
        element={<PropertiesPage />}
      /> */}
      <Route
        path="/property-for-:type/bedroom/:bedroom"
        element={<PropertiesPage />}
      />
      <Route
        path="/property-for-:type/in/:location"
        element={<PropertiesPage />}
      />
      <Route
        path="/property-for-:type/:kind/in/:location"
        element={<PropertiesPage />}
      />
      <Route path="/property-for-:type/in" element={<PropertiesPage />} />

      <Route
        path="/property-for-shortlet/in/:location"
        element={<PropertiesPage />}
      />
      <Route path="/sign-in" element={<Navigate to="/" replace />} />
      <Route path="/get-started" element={<Navigate to="/" replace />} />
      <Route element={<SessionRoutes />}>
        <Route path="/forgot-password" element={<ResetPassword />} />
        <Route path="/reverify-email" element={<ReverifyEmail />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route
          path="/change-password/success"
          element={<ChangePasswordSuccess />}
        />
        <Route
          path="/get-started/developer-upload"
          element={<DeveloperUpload />}
        />
        <Route path="/redirect" element={<RedirectPage />} />
        <Route path="/me/verify-account" element={<VerifyEmail />} />
        <Route path="/account-selection" element={<AccountSelection />} />
      </Route>
      <Route path="/get-started/:type" element={<Navigate to="/" replace />} />
      <Route element={<PrivateRoutes />}>
        <Route path="/profile" element={<Profile />} />
        <Route path="/profile/edit/" element={<EditProfile />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/messaging" element={<Messaging />} />
        <Route path="/messaging/:id" element={<Messaging />} />
        <Route path="/profile/transactions/form-ext" element={<Messaging />} />
        <Route
          path="/transaction/:id/availabilty"
          element={<AcceptTransaction />}
        />
        <Route path="/transaction/:id/pick-a-date" element={<PickAdate />} />
      </Route>
      <Route element={<PrivateRoutes roleOnly="developer" />}>
        <Route path="/developer-dashboard" element={<DevelopersDashboard />} />
        <Route path="/developer-projects" element={<Projects />} />
        <Route path="/my-projects/:id" element={<ProjectDetails />} />
        <Route path="/developer/project-form" element={<ProjectForm />} />
        <Route path="/developer-profile" element={<DevelopersProfile />} />
        <Route
          path="/developer-profile/edit"
          element={<EditDeveloperProfile />}
        />
        <Route path="/my-project-property/:id" element={<ProjectProperty />} />
        <Route path="/developer-settings" element={<DevelopersSettings />} />
        <Route path="/developer-sales" element={<DevelopersSales />} />
        <Route path="/developer/add-property" element={<AddProperty />} />
        <Route path="/developer-forum" element={<DevMessaging />} />
        <Route path="/developer-forum/add" element={<AddNewForum />} />
        <Route
          path="/dev-interest-details/:id"
          element={<DevInterestDetails />}
        />
      </Route>
      <Route element={<PrivateRoutes roleOnly="landlord" />}>
        <Route path="/overview" element={<Overview />} />
        <Route path="/wallet" element={<HostWallet />} />
        <Route path="/caution-fee" element={<Wallet />} />
        <Route path="/caution-fee/:id" element={<CautionFeeDetails />} />
        <Route path="/listings" element={<Listing />} />
        <Route path="/requests" element={<AllRequests />} />
        <Route path="/requests/:id" element={<RequestBookingDetail />} />
        <Route path="/listings/:type" element={<ListProperty />} />
      </Route>
      <Route element={<PrivateRoutes roleOnly="agent" />}>
        <Route path="/overview" element={<Overview />} />
        <Route path="/wallet" element={<HostWallet />} />
        <Route path="/caution-fee" element={<Wallet />} />
        <Route path="/caution-fee/:id" element={<CautionFeeDetails />} />
        <Route path="/listings" element={<Listing />} />
        <Route path="/requests" element={<AllRequests />} />
        <Route path="/requests/:id" element={<RequestBookingDetail />} />
        <Route path="/listings/:type" element={<ListProperty />} />
      </Route>

      <Route element={<PrivateRoutes roleOnly="property-manager" />}>
        <Route path="/overview" element={<Overview />} />
        <Route path="/wallet" element={<HostWallet />} />
        <Route path="/caution-fee" element={<Wallet />} />
        <Route path="/caution-fee/:id" element={<CautionFeeDetails />} />
        <Route path="/listings" element={<Listing />} />
        <Route path="/requests" element={<AllRequests />} />
        <Route path="/requests/:id" element={<RequestBookingDetail />} />
        <Route path="/listings/:type" element={<ListProperty />} />
      </Route>

      <Route element={<PrivateRoutes roleOnly="user" />}>
        <Route path="/invoice" element={<Invoice />} />
        <Route path="/purchases" element={<Purchases />} />
        <Route path="/my-bookings" element={<MyBookings />} />
        <Route path="/my-bookings/:id" element={<BookingDetail />} />
        <Route path="/my-bookings/:id/receipt" element={<BookingReceipt />} />
        <Route path="/my-bookings/:id/renew" element={<RenewRent />} />
        <Route path="/dashboard" element={<UsersDashboard />} />
        <Route path="/explore-listings" element={<Explore />} />
        <Route path="/caution-fee" element={<Wallet />} />
        <Route path="/caution-fee/:id" element={<CautionFeeDetails />} />
        <Route path="/my-properties" element={<MyProperties />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/transaction/success" element={<PaymentSuccessPage />} />
        <Route
          path="/interest-details/:id"
          element={<UserInterestPropertyDetails />}
        />
        <Route
          path="/purchase-details/:id"
          element={<UserPurchasedPropertyDetails />}
        />

        <Route
          path="/transaction/confirmation"
          element={<PaymentSuccessPage />}
        />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};
export default AppRouter;
